import { Dispatch, SetStateAction } from "react";
import BulkUpload from "./BulkUpload";

export const BulkUploadCustomers = ({
  fileUploadState,
  setFileUploadState,
  isAddBulkCustomersLoading,
}: {
  fileUploadState: any;
  setFileUploadState: any;
  isAddBulkCustomersLoading: boolean;
}) => {
  return (
    <BulkUpload
      fileUploadState={fileUploadState}
      setFileUploadState={setFileUploadState}
      isLoading={isAddBulkCustomersLoading}
      type="customers"
    />
  );
};
